module.exports = __webpack_public_path__ + "img/full1-min.214db670.png";